import { Ability } from '@casl/ability'
import { initialAbility } from './config'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
let existingAbility = null
try {
  existingAbility = JSON.parse(localStorage.getItem('userAbility'))
} catch {
  // Bozuk veri uygulamayı açılışta çökertmesin; varsayılan yetkiyle devam edilir
}

export default new Ability(existingAbility || initialAbility)
